import React from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { TransitionProps } from '@mui/material/transitions';
import toast from 'react-hot-toast';
import api from '../../../services/axios';
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="up" ref={ref} {...props} />;
});
interface AlertDialogDeleteProps {
    isAlertDeleteOpen: boolean
    setIsAlertDeleteOpen: (valor: boolean) => void
    setContacts: (contact: any) => void
    contacts: any[]
    cnpj_cpf: string
    idDelete: number
}

function AlertDelete({ isAlertDeleteOpen, setIsAlertDeleteOpen, cnpj_cpf, idDelete, contacts, setContacts }: AlertDialogDeleteProps) {
  const handleDelete = async () => {
    if(idDelete !== 0) {
      try {
        await api.delete(`/contatos/${cnpj_cpf}/${idDelete}`)
        const newContacts = contacts.filter((contact: any) => contact.id !== idDelete)
        setContacts(newContacts)
        } catch (error) {
          toast.error('Desculpe, não foi possível excluir este contato')
        }
    }
    setIsAlertDeleteOpen(false);
  };

  function handleClose() {
    setIsAlertDeleteOpen(false);
  }

  if(!isAlertDeleteOpen) {
    return null
  }

  return (
    <div>
      <Dialog
        open={isAlertDeleteOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>Deletar contato</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Tem certeza que deseja excluir este contato?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancelar</Button>
          <Button onClick={handleDelete}>Excluir</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default AlertDelete